module.exports = __webpack_public_path__ + "img/IMG_3950.cb2d3abc.jpg";